<div style="display: flex;flex-direction: row;margin-top: 30px; margin-bottom: 30px">
    <div style="flex-direction: column;width: 100%" *ngrxLet="text$; let data">
        <div style="color: rgba(42,102,83,255);font-size: large" [innerHTML]="data.key"></div>
        <div style="margin-top: 23px;font-weight: 600;font-size: large;color: #F39205;">
            {{data.value}}
        </div>
    </div>
    <div style="flex-direction: column;display: flex;justify-content: center;align-items: flex-end">
        <div class="group-header-emprunteur">
            <div style="text-align: center;font-weight: bold;height: 100%;justify-content: center;align-items: center;display: flex;">
                GROUPAMA EMPRUNTEUR
            </div>
            <div class="line-separator"></div>
            <div style="text-align: center;font-size: 12px;height: 100%;justify-content: center;align-items: center;display: flex;">
                Réalisez jusqu'à 15 000 € (2) d'économies ! <br>
                Planifiez un rendez-vous avec un conseiller spécialisé
            </div>
        </div>
    </div>
</div>
